import type { IUserRepository } from '../repositories/IUserRepository.js';
import type { PermissionRuleEntity } from '../entities/UserEntity.js';

interface Dependencies {
  userRepository: IUserRepository;
}

export function createGetMyPermissionsUseCase({ userRepository }: Dependencies) {
  return async function getMyPermissions(input: {
    orgId: string;
    projectId?: string;
  }): Promise<PermissionRuleEntity[]> {
    if (input.projectId) {
      return userRepository.getMyProjectPermissions(input.orgId, input.projectId);
    }
    return userRepository.getMyPermissions(input.orgId);
  };
}
